import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, tap } from 'rxjs';

export interface MaintenanceState {
  enabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private maintenance = signal(false);
  private http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl + '/maintenance';

  isInMaintenance = this.maintenance.asReadonly();

  enter(): void {
    this.maintenance.set(true);
  }

  enableMaintenance(): Observable<MaintenanceState> {
    return this.http.put<MaintenanceState>(this.apiUrl, null).pipe(tap((state) => this.maintenance.set(state.enabled)));
  }

  disableMaintenance(): Observable<MaintenanceState> {
    return this.http.delete<MaintenanceState>(this.apiUrl).pipe(tap((state) => this.maintenance.set(state.enabled)));
  }

  getMaintenanceStatus(): Observable<MaintenanceState> {
    return this.http.get<MaintenanceState>(this.apiUrl).pipe(tap((state) => this.maintenance.set(state.enabled)));
  }
}
